// /var/www/aesirerp_lp/frontend/src/components/footer/Footer.tsx
'use client';
import Image from 'next/image';
import Link from 'next/link';
import { FaInstagram, FaFacebookF, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';
import { MapPin, Mail, Globe, ShieldCheck } from 'lucide-react';
import styles from './Footer.module.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        
        {/* COLUNA 1: BRANDING & SEO */}
        <div className={styles.brandColumn}>
          <Link href="#inicio" className={styles.logo} aria-label="Voltar para o Início">
            <Image src="/assets/images/logo.png" alt="Logo Aesir ERP" width={28} height={28} />
            <span>Aesir ERP</span>
          </Link>
          <p className={styles.seoText}>
            O Aesir ERP é uma plataforma de gestão empresarial (SaaS) desenvolvida para auxiliar empresas no controle de vendas, emissão de notas fiscais, gestão financeira, recursos humanos e automação de marketing via WhatsApp API. Nossa missão é centralizar operações comerciais em uma interface unificada e segura.
          </p>
          <div className={styles.socialRow}>
            <a href="https://www.instagram.com/aesirerp/" target="_blank" rel="noopener noreferrer" aria-label="Instagram Aesir"><FaInstagram size={18} /></a>
            <a href="https://www.facebook.com/people/Aesir-ERP/61570898695821/" target="_blank" rel="noopener noreferrer" aria-label="Facebook Aesir"><FaFacebookF size={18} /></a>
            <a href="https://www.linkedin.com/company/aesirerp" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn Aesir"><FaLinkedinIn size={18} /></a>
            <a href="https://api.whatsapp.com/send/?phone=5511983493522" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp Aesir"><FaWhatsapp size={18} /></a>
          </div>
        </div>

        {/* COLUNA 2: MÓDULOS */}
        <div className={styles.column}>
          <h4>Soluções</h4>
          <ul className={styles.linkList}>
            <li><Link href="#modulos">Vendas & PDV</Link></li>
            <li><Link href="#modulos">Aesir Chat (Omni)</Link></li>
            <li><Link href="#modulos">Financeiro & NFe</Link></li>
            <li><Link href="#modulos">Recursos Humanos</Link></li>
            <li><Link href="#modulos">Ordens de Serviço</Link></li>
          </ul>
        </div>

        {/* 👇 COLUNA 3 NOVA: SEO & CASOS DE USO 👇 */}
        <div className={styles.column}>
          <h4>Casos de Uso</h4>
          <ul className={styles.linkList}>
            <li><Link href="/segmentos/loja-de-celular" title="Sistema para Loja de Celular">Lojas de Celular</Link></li>
            <li><Link href="/segmentos/mercado-livre" title="ERP para Mercado Livre">Mercado Livre</Link></li>
            <li><Link href="/segmentos/shopee" title="ERP Integrado Shopee">Shopee</Link></li>
            <li><Link href="/alternativas/bling" title="Alternativa ao Bling">Alternativa ao Bling</Link></li>
            <li><Link href="/alternativas/omie" title="Alternativa ao Omie">Alternativa ao Omie</Link></li>
          </ul>
        </div>

        {/* COLUNA 4: ATENDIMENTO & EMPRESA */}
        <div className={styles.column}>
          <h4>Empresa e Atendimento</h4>
          <ul className={styles.linkList}>
            <li><Link href="#faq">Central de Ajuda (FAQ)</Link></li>
            <li><Link href="#parceiros">Seja Parceiro (White Label)</Link></li>
            <li>
              <ShieldCheck size={16} color="var(--md-sys-color-primary)"/>
              <span style={{marginLeft: '6px', fontSize: '0.85rem'}}>CNPJ: 60.705.240/0001-13</span>
            </li>
            <li>
              <Mail size={16} color="var(--md-sys-color-primary)"/>
              <span style={{marginLeft: '6px', fontSize: '0.85rem'}}>comercial@aesirerp.com</span>
            </li>
          </ul>
          
          <a href="https://api.whatsapp.com/send/?phone=5511983493522" target="_blank" rel="noopener noreferrer" className={styles.whatsappFloat}>
            <FaWhatsapp size={18} /> Falar no WhatsApp
          </a>
        </div>

      </div>

      {/* BARRA INFERIOR DE COPYRIGHT */}
      <div className={styles.bottomBar}>
        <div>
          &copy; {currentYear} Aesir ERP LTDA. Todos os direitos reservados.
        </div>
        <div className={styles.legalLinks}>
          <Link href="/termos">Termos de Uso</Link>
          <Link href="/privacidade">Política de Privacidade</Link>
        </div>
      </div>
    </footer>
  );
}